import React, { Suspense } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import Main from './Main';
import Providers from './Providers';
import { ErrorBoundary } from './modules/shared';
import { FullScreenLoader } from './ui-kit';

const App = () => {
    return (
        <Router>
            <Providers>
                <Suspense fallback={<FullScreenLoader />}>
                    <ErrorBoundary>
                        <Main />
                    </ErrorBoundary>
                </Suspense>
            </Providers>
        </Router>
    );
};

export default App;
